import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { SoilBand } from './ui/SoilBand';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-field-deep text-field-light" data-id="element-106" data-mp="32nummremu92y">
      <SoilBand data-id="element-107" data-mp="32pfgsfx1bq0a" />
      <div className="mx-auto max-w-3xl px-4 py-12 text-center" data-id="element-108" data-mp="32lrlbb814tix">
        <p className="font-display text-lg font-extrabold uppercase text-cream" data-id="element-109" data-mp="36q9354utwwr2">{productName}</p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed" data-id="element-110" data-mp="3ug3bpa847z5i">
          Hecho por especialistas en geología del petróleo y educación, para docentes, instructores y formadores de toda
          Argentina.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-semibold leading-relaxed text-gold" data-id="element-111" data-mp="3le2j4qntu1a6">
          “La próxima clase que des, podés entrar al aula sabiendo que sos el profesional que enseña que comprender los
          yacimientos es comprender la energía que mueve el mundo.”
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-112" data-mp="2ezurzge79yj3">
          <a href="mailto:packcentral23@gmail.com" className="inline-flex items-center gap-2 text-sm font-bold text-gold transition-colors duration-150 ease-out hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-113" data-mp="3la2akxul99wt">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="3q8n0a3c7sb70" /> packcentral23@gmail.com
          </a>
          <a href="https://instagram.com/centralpack.ar" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-gold transition-colors duration-150 ease-out hover:text-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-115" data-mp="830iphfda2zy">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="ctqouwvma9vp" /> @centralpack.ar
          </a>
        </div>
        <p className="mt-8 border-t border-field-soft pt-6 text-xs" data-id="element-117" data-mp="qt8hjnc1a7ac">
          © {productName} 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}